import React from 'react'
import AssetShape from './AssetShape'
import { useVideoChromaKey } from '../../useVideoChromaKey'

const VideoAssetOverlay = React.memo(({
  asset,
  index,
  size,
  scale,
  boundingRect,
  extSourcePos,
  extSourceSize,
  extSourceRotation,
  videoRefs,
  animation,
  onChange,
}) => {
  const chromaKeyCanvas = useVideoChromaKey({
    key: `chroma-${asset.id}`,
    asset,
    ...size,
    boundingRect,
    videoRef: videoRefs?.[asset.id],
  })
  const source = chromaKeyCanvas ?? videoRefs?.[asset.id]?.current

  return (
    <If condition={source}>
      <AssetShape
        asset={asset}
        index={index}
        size={size}
        scale={scale}
        source={source}
        settings={asset.settings}
        boundingRect={boundingRect}
        extSourcePos={extSourcePos}
        extSourceSize={extSourceSize}
        extSourceRotation={extSourceRotation}
        animation={animation}
        onChange={onChange}
      />
    </If>
  )
})

export default VideoAssetOverlay
